function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18.251 18.591c.689-.181 1.23-.692 1.415-1.37.31-1.14.332-3.431.334-3.753v-.075c-.002-.322-.024-2.613-.334-3.753a1.988 1.988 0 00-1.415-1.392c-1.074-.284-4.934-.323-5.985-.329h-.532c-1.051.006-4.91.045-5.985.329A1.988 1.988 0 004.334 9.64c-.31 1.14-.332 3.431-.334 3.753v.075c.002.322.024 2.613.334 3.753.184.678.726 1.189 1.415 1.37 1.074.284 4.934.323 5.985.328h.532c1.051-.005 4.91-.044 5.985-.328zm-7.887-2.834v-4.653l4.181 2.326-4.181 2.327z",
  fill: "#0558E6",
  fillRule: "evenodd"
});

function SvgYoutubeinline(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25"
  }, props), _ref);
}

export default SvgYoutubeinline;